import { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { checklistActions } from '../../util/store/checklist/reducer';
import Checklists from "./Checklists";

const ChecklistPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(checklistActions.gets());
    }, [dispatch]);

    return <div className='m-header bgPage'>
        <div className='header-page mb-3'>
            <div className='title-page'>
                <span>Setting: </span>
                <b>Checklist Management</b>
            </div>
        </div>
        <Checklists />
    </div>;
};

export default ChecklistPage;
